import React from 'react';
import type { BiomarkerStatusResult } from '../../utils/biomarkerStatus';

/**
 * Shared In range / High / Low pill, driven by the status engine. Used on the
 * biomarker rows and the "Latest biomarker" intelligence card so the status
 * language reads identically wherever a biomarker appears.
 */
export default function BiomarkerStatusPill({ status }: { status: BiomarkerStatusResult }) {
  if (status.status === 'unknown') return null;
  return (
    <span
      className="inline-flex items-center text-[10px] font-medium uppercase tracking-[0.16em]"
      style={{
        // BRAND v3 "LEDGER": an outlined rectangle, not a filled lozenge. The
        // status tint stays available as `softBackground` for range bars, but
        // a pill that is both filled and coloured competes with the reading it
        // is annotating.
        color: status.color,
        border: `1px solid ${status.color}`,
        backgroundColor: 'transparent',
        padding: '3px 9px',
      }}
    >
      {status.label}
    </span>
  );
}
